import api from "./api";

const qs = (p) => new URLSearchParams(
  Object.entries(p).filter(([, v]) => v !== "" && v !== undefined && v !== null)
);

const comprasService = {
  meta: () => api("GET", "/compras/meta"),
  listar: (p = {}) => api("GET", `/compras?${qs(p)}`),
  buscarPorId: (id) => api("GET", `/compras/${id}`),
  criar: (data) => api("POST", "/compras", data),
  criarDePedido: (data) => api("POST", "/compras/de-pedido", data),
  atualizar: (id, data) => api("PUT", `/compras/${id}`, data),
  receber: (id, data) => api("POST", `/compras/${id}/receber`, data),
  gerarContaPagar: (id, data) => api("POST", `/compras/${id}/gerar-conta-pagar`, data),
  cancelar: (id) => api("PATCH", `/compras/${id}/cancelar`, {}),
  importarXml: (data) => api("POST", "/compras/importar-xml", data),
};

export default comprasService;

export const STORAGE_OPEN_NOTA = "econdo_open_nota_id";
export const STORAGE_OPEN_CP = "econdo_open_cp_id";
